/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
import parse from "html-react-parser";
//import '../../css/event20210317.css'
import "../../css/event210521.css";

import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
import Slider from "react-slick";

class Event202105_open extends Component {
  state = {
    eventCode: 0,
    slideIndex: 0,
    slidePlay: true,
    bannerList: [
      {
        img: "/img/event/event210521/img1.png",
        title: "간편해진 인터페이스!",
        subTitle:
          "메인 화면에서 관람 중인 작품 리스트,<br>오늘의 업데이트, TOP 작품을 확인!",
      },
      {
        img: "/img/event/event210521/img22.png",
        title: "태그로 간편하게!",
        subTitle:
          "세분화된 태그들을 조합해서<br>나만의 원하는 작품을 쉽고 빠르게 서치!",
      },
      {
        img: "/img/event/event210521/img33.png",
        title: "영상 내 인터페이스 강화!",
        subTitle:
          "화면 자동 전환, 영상 배속, 스킵기능, 화질 선택<br>다음화 자동재생 등 영상 기능이 새롭게 추가!",
      },
      {
        img: "/img/event/event210521/img44.png",
        title: "친구 추천하고 포인트 받자!",
        subTitle:
          "친구 추천하면 애니플러스 포인트가 와르르~!?<br>친구와 함께 VOD와 굿즈 구매를 FLEX~!",
      },
    ],
  };

  _goVod = (code) => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    if (code === "4" || code === "5") {
      history.push("/list?q=tag&c=" + code);
    } else {
      history.push("/list?q=genre&c=" + code);
    }
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _pass = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push("/ticket");
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    if (today <= "2021-03-31 00:00:00") {
      toast.warn("3월 31일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      setTimelineWeek(true);
    }
  };
  _renderItem = () => {
    const { bannerList } = this.state;
    ////console.log(bannerList)
    const list = bannerList.map((item, index) => {
      return (
        <li key={index}>
          <img src={item.img} />
        </li>
      );
    });

    return list;
  };
  _renderDot = () => {
    const { bannerList, slideIndex } = this.state;

    const list = bannerList.map((item, index) => {
      return (
        <li key={index} className={slideIndex === index ? "active" : null}></li>
        /*<a key={index} href="#" className="on"></a>*/
      );
    });

    return list;
  };
  _renderTitle = () => {
    const { bannerList, slideIndex } = this.state;

    const list = bannerList.map((item, index) => {
      return (
        <li key={index} style={{ display: slideIndex === index ? "" : "none" }}>
          <h3>{item.title}</h3>
          <p>{parse(item.subTitle)}</p>
        </li>
        /*<a key={index} href="#" className="on"></a>*/
      );
    });

    return list;
  };
  _goEvent = () => {
    window.open("https://forms.gle/Ta6YjEUX9FNPnFTS8", "", "");
  };
  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  render() {
    const { bannerList } = this.state;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      //adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };

    return (
      <Fragment>
        <div className="event_head">
          {/*<button type="button" onclick="history.back()"><img src="//img/event/back.png" alt="뒤로"/></button>*/}
          <h3>애니플러스 모바일앱 리뉴얼 이벤트</h3>
          <button type="button" className="btnClose" onClick={this._onBack}>
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event210521">
            <div className="qrWrap">
              <img src="/img/event/event210521/qr_an.png" alt="안드로이드" />
              <img src="/img/event/event210521/qr_ios.png" alt="ios" />
            </div>
            <div className="btnWrap">
              <button type="button" onClick={this._goEvent}>
                <img src="/img/event/event210521/btn_go.png" alt="응모하기" />
              </button>
            </div>
            <div className="eventSwipeWrap">
              <ul className="img">
                <Slider ref={(ref) => (this.slider = ref)} {...settings}>
                  {bannerList ? this._renderItem() : null}
                </Slider>
              </ul>

              <ul className="ment">
                {bannerList ? this._renderTitle() : null}
              </ul>
              <ul className="paging">
                {bannerList ? this._renderDot() : null}
              </ul>
            </div>
            <img
              src="/img/event/event210521/backimg.png"
              alt="애니플러스 모바일앱 리뉴얼 이벤트"
              className="img_web"
            />
            <img
              src="/img/event/event210521/backimg_m.png"
              alt="애니플러스 모바일앱 리뉴얼 이벤트"
              className="img_mobile"
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202105_open));
